exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home_2cbaba3{height:calc(100vh - 148px);height:calc(100vh - var(--gutter-x-4));display:flex;align-items:center;justify-content:center;flex-direction:column;font-size:55px;letter-spacing:.2em;color:#ccc;background-color:#fff}", ""]);

// exports
exports.locals = {
	"home": "home_2cbaba3"
};